module.exports = __webpack_public_path__ + "d055ba9978140141a3cfa274d1877636.svg";